import React, { useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { forgotPasswordverifyOtp } from '../services/auth'; // You must create this API function

const OtpVerification: React.FC = () => {
  const { id } = useParams(); // Grab user ID from URL
  const [otp, setOtp] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [apiError, setApiError] = useState('');

  const handleChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const validateOtp = () => {
    const joined = otp.join('');
    if (joined.length !== 4 || !/^\d{4}$/.test(joined)) {
      setError('Please enter a valid 4-digit OTP.');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateOtp()) return;
    setLoading(true);
    setError('');

    try {
      const code = otp.join('');
      if (code.length !== 4) {
        setError('Please enter a valid 4-digit OTP');
        return;
      }
      const result = await forgotPasswordverifyOtp({ id, otp: code }); // Implement this API
      console.log('OTP verified:', result);
      // Navigate to dashboard or next step
    } catch (err: any) {
      const apiErrorMessage = err.response?.data?.message || 'OTP verification failed';
      setError(apiErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white rounded-2xl shadow-lg flex max-w-4xl w-full">
        
        {/* Left Panel - Logo */}
        <div className="w-1/2 bg-gradient-to-br from-green-400 to-green-600 text-white flex flex-col items-center justify-center rounded-l-2xl p-8">
          <img src={require('../assets/logo.png')} alt="Logo" className="w-40 h-40 object-contain mb-4" />
          <h2 className="text-2xl font-bold">Verify OTP</h2>
          <p className="text-center mt-2">Enter the 4-digit code sent to your email</p>
        </div>

        {/* Right Panel - OTP Form */}
        <div className="w-1/2 p-8">
          <h2 className="text-3xl font-semibold text-gray-800 mb-6">OTP Verification</h2>
          <form onSubmit={handleSubmit} className="space-y-6">

            {/* API Error */}
            {error && (
              <div className="bg-red-100 text-red-700 text-sm p-3 rounded-md text-center">
                {error}
              </div>
            )}

            {/* OTP Inputs */}
            <div className="flex justify-between space-x-4">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => {
                    inputRefs.current[index] = el;
                  }}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-14 h-14 text-center text-xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />
              ))}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition duration-200"
            >
              {loading ? 'Verifying...' : 'Verify OTP'}
            </button>

            {/* Resend Link */}
            <div className="text-center mt-4">
              <p className="text-sm">
                Didn't receive the code?{' '}
                <button
                  type="button"
                  className="text-green-600 hover:underline"
                  onClick={() => alert('Resend OTP logic goes here')}
                >
                  Resend OTP
                </button>
              </p>
            </div>

            {/* Back to Login */}
            <div className="text-center mt-2">
              <Link to="/login" className="text-sm text-green-600 hover:underline">
                Back to Login
              </Link>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
